
export default {
  SET_TOKEN(state, token) {
    state.token = token
  },
  REMOVE_TOKEN(state, token) {
    state.token = null
  },
  SET_USER(state, data) {
    state.user = data
  },
  UPDATE(state, name) {
    state.user.name = name
  },
  SET_ROLE(state, role) {
    state.role = role
  },
  REMOVE_ROLE(state, role) {
    state.role = null
  },
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications
  },

  READ_NOTIFICATION(state, itemId) {
      const ItemIndex = state.notifications.findIndex((p) => p.id == itemId)
      state.notifications.splice(ItemIndex, 1)
  }
  
}
